module.exports = __webpack_public_path__ + "img/lower_mvbg.e445a0c8.jpg";